import React, { useState } from 'react'
import ReactFullscreen from "react-full-screen";


const RessourceFullscreenable = ({ className, imageSize, downloadURL, index, handleDeleteResource, id, fileNumber }) => {

    const [fullscreen, setFullscreen] = useState(false)

    return (
        <ReactFullscreen enabled={fullscreen}>
            <div className="image-container hidden-xs hidden-sm">
                <img
                    className={fullscreen ? 'img-responsive' : 'margin-bottom-medium pointer'}
                    width={266 * imageSize}
                    height={150 * imageSize}
                    src={downloadURL}
                    alt={`resouce${index}`}
                    onClick={() => setFullscreen(!fullscreen)}
                />
                {fullscreen ?
                    ''
                    :
                    <div
                        className={fileNumber > 3 ? 'delete-image' : 'delete-image-sm'}
                        onClick={() => handleDeleteResource(id)}
                    >X</div>
                }
            </div>
        </ReactFullscreen >
    )
}

export default RessourceFullscreenable
